function getBrowserLocales(options = {}) {
  const defaultOptions = {
    languageCodeOnly: false
  };

  const opt = {
    ...defaultOptions,
    ...options
  };

  const browserLocales = navigator.languages === undefined ? [navigator.language] : navigator.languages;

  if (!browserLocales) {
    return;
  }

  // TODO: Issue MRP-2772
  // eslint-disable-next-line consistent-return
  return browserLocales.map(locale => {
    const trimmedLocale = locale.trim();

    return opt.languageCodeOnly ? trimmedLocale.split(/-|_/)[0] : trimmedLocale;
  });
}

export const DEFAULT_LOCALE = getBrowserLocales() ?? ["en-US", "en"];

export function formatNumber(num, { locale = DEFAULT_LOCALE, options = {} } = {}) {
  const formatter = new Intl.NumberFormat(locale, options);
  const value = formatter.format(num);

  // TODO: Issue MRP-2772
  // eslint-disable-next-line unicorn/no-null
  if (value === "NaN")
    // TODO: Issue MRP-2775
    // eslint-disable-next-line unicorn/no-null
    return null;
  return value;
}
